import portalReducer from './portalReducer';

const rootReducer = portalReducer;

export default rootReducer;

